// Extended SAP values and oil properties for quality calculations
export const OIL_DATABASE = [
  { name: "Coconut Oil", sapNaOH: 0.178, sapKOH: 0.249, hardness: 79, cleansing: 67, conditioning: 10, bubbly: 67, creamy: 12 },
  { name: "Olive Oil", sapNaOH: 0.134, sapKOH: 0.188, hardness: 17, cleansing: 0, conditioning: 82, bubbly: 0, creamy: 17 },
  { name: "Palm Oil", sapNaOH: 0.141, sapKOH: 0.197, hardness: 49, cleansing: 1, conditioning: 49, bubbly: 1, creamy: 48 },
  { name: "Shea Butter", sapNaOH: 0.128, sapKOH: 0.179, hardness: 43, cleansing: 0, conditioning: 56, bubbly: 0, creamy: 43 },
  { name: "Castor Oil", sapNaOH: 0.128, sapKOH: 0.179, hardness: 0, cleansing: 0, conditioning: 90, bubbly: 90, creamy: 0 },
  { name: "Cocoa Butter", sapNaOH: 0.137, sapKOH: 0.192, hardness: 57, cleansing: 0, conditioning: 43, bubbly: 0, creamy: 57 },
  { name: "Lard", sapNaOH: 0.138, sapKOH: 0.193, hardness: 41, cleansing: 0, conditioning: 58, bubbly: 0, creamy: 41 },
  { name: "Sweet Almond Oil", sapNaOH: 0.136, sapKOH: 0.190, hardness: 9, cleansing: 0, conditioning: 89, bubbly: 0, creamy: 9 },
  { name: "Avocado Oil", sapNaOH: 0.133, sapKOH: 0.186, hardness: 7, cleansing: 0, conditioning: 91, bubbly: 0, creamy: 7 },
  { name: "Rice Bran Oil", sapNaOH: 0.128, sapKOH: 0.179, hardness: 18, cleansing: 0, conditioning: 80, bubbly: 0, creamy: 18 },
  { name: "Sunflower Oil", sapNaOH: 0.134, sapKOH: 0.188, hardness: 10, cleansing: 0, conditioning: 88, bubbly: 0, creamy: 10 },
  { name: "Canola Oil", sapNaOH: 0.132, sapKOH: 0.185, hardness: 11, cleansing: 0, conditioning: 87, bubbly: 0, creamy: 11 },
  { name: "Hemp Oil", sapNaOH: 0.135, sapKOH: 0.189, hardness: 8, cleansing: 0, conditioning: 90, bubbly: 0, creamy: 8 },
  { name: "Jojoba Oil", sapNaOH: 0.069, sapKOH: 0.097, hardness: 5, cleansing: 0, conditioning: 94, bubbly: 0, creamy: 5 },
  { name: "Safflower Oil", sapNaOH: 0.136, sapKOH: 0.190, hardness: 9, cleansing: 0, conditioning: 89, bubbly: 0, creamy: 9 },
] as const

export type Unit = "grams" | "ounces"
export type LiquidType = "water" | "goat-milk" | "aloe-juice"
export type LyeType = "NaOH" | "KOH"
export type LyeCalculationMode = "concentration" | "ratio"

export interface OilEntry {
  id: string
  oil: string
  percentage: number
  weight: number
  costPerUnit: number
}

export interface OilWithWeight extends OilEntry {
  weight: number
}

export interface SoapCalculations {
  totalOilWeight: number
  totalLyeRequired: number
  totalLiquid: number
  fragranceLoad: number
  totalBatchWeight: number
  totalPercentage: number
  hardness: number
  cleansing: number
  conditioning: number
  bubbly: number
  creamy: number
  totalCost: number
  oilsWithCalculatedWeights: OilWithWeight[]
}

export const QUALITY_RANGES = {
  hardness: { min: 29, max: 54 },
  cleansing: { min: 12, max: 22 },
  conditioning: { min: 44, max: 69 },
  bubbly: { min: 14, max: 46 },
  creamy: { min: 16, max: 48 },
} as const

export function getQualityRating(value: number, min: number, max: number) {
  if (value < min) return { status: "low" as const, color: "bg-yellow-500" }
  if (value > max) return { status: "high" as const, color: "bg-yellow-500" }
  return { status: "optimal" as const, color: "bg-emerald-500" }
}
